export const rows = [
  {
    id: 1,
    username: "Harshit Behl",
    avatar:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2070&q=80",
    email: "harshit.behl.96@gmail.com",
    status: "active",
    transaction: "$120",
  },
  {
    id: 2,
    username: "Harshit Behl",
    avatar:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2070&q=80",
    email: "harshit.behl.96@gmail.com",
    status: "active",
    transaction: "$120",
  },
  {
    id: 3,
    username: "Harshit Behl",
    avatar:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2070&q=80",
    email: "harshit.behl.96@gmail.com",
    status: "active",
    transaction: "$120",
  },
  {
    id: 4,
    username: "Harshit Behl",
    avatar:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2070&q=80",
    email: "harshit.behl.96@gmail.com",
    status: "active",
    transaction: "$120",
  },
  {
    id: 5,
    username: "Harshit Behl",
    avatar:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2070&q=80",
    email: "harshit.behl.96@gmail.com",
    status: "active",
    transaction: "$120",
  },
];
